export const DELIVERY_PAGE_BF = 'DELIVERY_PAGE';
export const SSO_BROKER_BF = 'SSO_BROKER';
